import React from 'react'
import PropTypes from 'prop-types'
import Modal from '../Modal'

const ConfirmModal = ({
  isOpen, title, onConfirm, onCancel, children,
  confirmLabel,
  cancelLabel
}) => (
  <Modal
    isOpen={isOpen}
    title={title}
    footer={(
      <>
        <button
          type="button"
          className="btn btn-light border"
          onClick={onCancel}
        >
          {cancelLabel}
        </button>
        <button
          type="button"
          className="btn btn-danger"
          onClick={onConfirm}
        >
          {confirmLabel}
        </button>
      </>
    )}
    onClose={onCancel}
  >
    {children}
  </Modal>
)

ConfirmModal.propTypes = {
  cancelLabel: PropTypes.string,
  children: PropTypes.node.isRequired,
  confirmLabel: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
}

ConfirmModal.defaultProps = {
  cancelLabel: 'Annuler',
  confirmLabel: 'Confirmer'
}

export default ConfirmModal
